import { WEB_COLORS } from "@/lib/constants";
import { CurrencyConverter } from "@/lib/constants/Functions";
import { Slider, Stack, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

const SliderComponent = ({
  min = 50000,
  max = 500000,
  amountRequired = false,
  formatRequired = true,
  tenureRequired = false,
  minTenure = 18,
  maxTenure = 60,
  tenureStep = 6,
  handleTenureChange,
  tenure,
  showMinMax = true,
  ...props
}) => {
  const marks = [
    { value: 6, label: "6" },
    { value: 12, label: "12" },
    { value: 18, label: "18" },
    { value: 24, label: "24" },
    { value: 30, label: "30" },
    { value: 36, label: "36" },
    { value: 42, label: "42" },
    { value: 48, label: "48" },
    { value: 54, label: "54" },
    { value: 60, label: "60" },
  ];
  const t = useTranslations("ApplyLoan");
  return (
    <Stack>
      {amountRequired && (
        <>
          <Slider
            sx={{ height: 8 }}
            color="primary"
            min={min}
            max={max}
            {...props}
          />
          {showMinMax && (
            <Stack
              direction={"row"}
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle2" color={WEB_COLORS.fadeColor}>
                {t("min")} {formatRequired ? CurrencyConverter(min) : min}
              </Typography>
              <Typography variant="subtitle2" color={WEB_COLORS.fadeColor}>
                {t("max")} {formatRequired ? CurrencyConverter(max) : max}
              </Typography>
            </Stack>
          )}
        </>
      )}
      {tenureRequired && (
        <>
          <Slider
            onChange={handleTenureChange}
            color="primary"
            min={minTenure}
            max={maxTenure}
            step={tenureStep}
            value={tenure}
            marks={marks}
            sx={{ height: 8 }}
          />
          {showMinMax && (
            <Stack
              direction={"row"}
              sx={{
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="subtitle2">
                {t("min")} {minTenure} {t("months")}
              </Typography>
              <Typography variant="subtitle2">
                {t("max")} {maxTenure} {t("months")}
              </Typography>
            </Stack>
          )}
        </>
      )}
    </Stack>
  );
};

export default SliderComponent;
